import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit{
  title = 'HRMS';

  // Printing is handled entirely by the local Printer Agent (which subscribes
  // to Pusher directly). The web app no longer connects to any local printer.
  constructor() {}

  ngOnInit() {
    console.log('App initialized.');
  }

}
